import { IEquipment } from '@/pages/Equipment/equipment.types'

import parametersSelectors from '@/pages/Parameters/parameters.selectors'
import { IComputedParameterDef, TParameterKey } from '@/pages/Parameters/parameters.types'
import { useId, useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import useForceRerender from '@/shared/hooks/useForceRerender'
import useDataPointUpToTsWithComputedRef, {
  IUseDataPointUpToTsWithComputedRefProps,
} from './useDataPointUpToTsWithComputedRef'

interface IProps {
  parameters: TParameterKey[]
  computed?: IComputedParameterDef[]
  equipmentId: IEquipment['id']

  tsFrom: number
  tsTo: number
  tsCurrent: number
}

const useParametersValuesRange = (props: IProps) => {
  const forceRerender = useForceRerender()
  const dataSubscriptionId = useId()
  const sourceIdToIdMap = useRecoilValue(parametersSelectors.getSourceIdToIdMap)

  const config: Omit<IUseDataPointUpToTsWithComputedRefProps, 'tsCurrent'> = useMemo(() => {
    return {
      id: dataSubscriptionId,
      devices: [props.equipmentId],
      parameters: props.parameters,
      initialTsFrom: props.tsFrom,
      initialTsTo: props.tsTo,
      computed: props.computed ?? [],
      live: false,
      aggregate: false,
      onNewValueReceived: forceRerender,
    }
  }, [
    props.equipmentId,
    dataSubscriptionId,
    sourceIdToIdMap,
    props.tsFrom,
    props.tsTo,
    props.parameters,
    props.computed,
  ])

  const lastValues = useDataPointUpToTsWithComputedRef({ ...config, tsCurrent: props.tsCurrent })

  return {
    values: { ...(lastValues.ref.current[props.equipmentId] ?? {}) },
    loading: lastValues.loading,
  }
}

export default useParametersValuesRange
